"use strict";
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FeatureSegment = exports.FeatureStateModel = exports.MultivariateFeatureStateValueModel = exports.MultivariateFeatureOptionModel = exports.FeatureModel = void 0;
var uuid_1 = require("uuid");
var hashing_1 = require("../utils/hashing");
var FeatureModel = /** @class */ (function () {
    function FeatureModel(id, name, type) {
        this.id = id;
        this.name = name;
        this.type = type;
    }
    FeatureModel.prototype.eq = function (other) {
        return !!other && this.id === other.id;
    };
    return FeatureModel;
}());
exports.FeatureModel = FeatureModel;
var MultivariateFeatureOptionModel = /** @class */ (function () {
    function MultivariateFeatureOptionModel(value, id) {
        this.value = value;
        this.id = id;
    }
    return MultivariateFeatureOptionModel;
}());
exports.MultivariateFeatureOptionModel = MultivariateFeatureOptionModel;
var MultivariateFeatureStateValueModel = /** @class */ (function () {
    function MultivariateFeatureStateValueModel(multivariate_feature_option, percentage_allocation, id, mvFsValueUuid) {
        this.mvFsValueUuid = (0, uuid_1.v4)();
        this.id = id;
        this.percentageAllocation = percentage_allocation;
        this.multivariateFeatureOption = multivariate_feature_option;
        this.mvFsValueUuid = mvFsValueUuid || this.mvFsValueUuid;
    }
    return MultivariateFeatureStateValueModel;
}());
exports.MultivariateFeatureStateValueModel = MultivariateFeatureStateValueModel;
var FeatureStateModel = /** @class */ (function () {
    function FeatureStateModel(feature, enabled, djangoID, value, featurestateUuid) {
        if (featurestateUuid === void 0) { featurestateUuid = (0, uuid_1.v4)(); }
        this.featurestateUUID = (0, uuid_1.v4)();
        this.multivariateFeatureStateValues = [];
        this.feature = feature;
        this.enabled = enabled;
        this.djangoID = djangoID;
        this.value = value;
        this.featurestateUUID = featurestateUuid;
    }
    FeatureStateModel.prototype.setValue = function (value) {
        this.value = value;
    };
    FeatureStateModel.prototype.getValue = function (identityId) {
        if (!!identityId && this.multivariateFeatureStateValues.length > 0) {
            return this.getMultivariateValue(identityId);
        }
        return this.value;
    };
    /*
        Returns `True` if `this` is higher segment priority than `other`
        (i.e. has lower value for featureSegment.priority)
        NOTE:
            A segment will be considered higher priority only if:
            1. `other` does not have a feature segment(i.e: it is an environment feature state or it's a
            feature state with feature segment but from an old document that does not have `featureSegment.priority`)
            but `this` does.
            2. `other` have a feature segment with high priority
    */
    FeatureStateModel.prototype.isHigherSegmentPriority = function (other) {
        if (!other.featureSegment || !this.featureSegment) {
            return !!this.featureSegment && !other.featureSegment;
        }
        return this.featureSegment.priority < other.featureSegment.priority;
    };
    FeatureStateModel.prototype.getMultivariateValue = function (identityID) {
        var e_1, _a;
        var percentageValue;
        var startPercentage = 0;
        var sortedF = this.multivariateFeatureStateValues.sort(function (a, b) {
            return a.id - b.id;
        });
        try {
            for (var sortedF_1 = __values(sortedF), sortedF_1_1 = sortedF_1.next(); !sortedF_1_1.done; sortedF_1_1 = sortedF_1.next()) {
                var myValue = sortedF_1_1.value;
                switch (myValue.percentageAllocation) {
                    case 0:
                        continue;
                    case 100:
                        return myValue.multivariateFeatureOption.value;
                    default:
                        if (percentageValue === undefined) {
                            percentageValue = (0, hashing_1.getHashedPercentateForObjIds)([
                                this.djangoID || this.featurestateUUID,
                                identityID
                            ]);
                        }
                }
                var limit = myValue.percentageAllocation + startPercentage;
                if (startPercentage <= percentageValue && percentageValue < limit) {
                    return myValue.multivariateFeatureOption.value;
                }
                startPercentage = limit;
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (sortedF_1_1 && !sortedF_1_1.done && (_a = sortedF_1.return)) _a.call(sortedF_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
        return this.value;
    };
    return FeatureStateModel;
}());
exports.FeatureStateModel = FeatureStateModel;
var FeatureSegment = /** @class */ (function () {
    function FeatureSegment(priority) {
        this.priority = priority;
    }
    return FeatureSegment;
}());
exports.FeatureSegment = FeatureSegment;
